import {
  Stack,
  Radio,
  RadioGroup,
  Button,
  FormControlLabel,
  FormGroup,
  Checkbox,
} from "@mui/material";

import { ReactComponent as IconDiamond } from "../../../../../images/icon-diamond.svg";

import "../../styles.css";

import { FieldSelect, FieldDatePicker } from "../../../../../components/Fields";
import { formatDateISO8601 } from "../../../../../utils/formatarData";
import dayjs from "dayjs";
import "dayjs/locale/pt-br";

const ColumnSpan2 = ({ children }) => {
  return (
    <Stack sx={{ gridColumn: "span 2" }}>
      <Stack
        gap={"16px 24px"}
        sx={{
          display: "grid",
          gridTemplateColumns: "repeat(auto-fit, minmax(250px, 1fr))",
          boxSizing: "border-box !important",
        }}
        width="100%"
      >
        {children}
      </Stack>
    </Stack>
  );
};

export default function SegundaEtapa({
  handleChangePanel,
  onSubmit,
  setData,
  data,
  ventilacaoNaoInvasivaDuracaoOptions,
  traqueostomiaProcedimentoOptions,
  handleCheckedField,
  multidisciplinaridadeTipoOptions,
  tipoProcedimentoOptions,
  simOuNaoOptions,
  ...props
}) {
  function handleSetData(value, field) {
    setData((prevState) => ({
      ...prevState,
      [field]: value,
    }));
  }

  return (
    <Stack>
      <form autoComplete="off" onSubmit={onSubmit}>
        <Stack className="templateGridForm">
          <Stack>
            <Stack direction="row" className="labelText">
              Faz uso de ventilação não invasiva? (Bipap)
            </Stack>
            <RadioGroup row>
              {simOuNaoOptions.map(({ key, value }) => {
                return (
                  <FormControlLabel
                    value={value}
                    control={<Radio />}
                    label={key}
                    key={value}
                    checked={data.ventilacaoNaoInvasivaBIPAP === value}
                    onChange={(e) =>
                      handleSetData(
                        e.target.value,
                        "ventilacaoNaoInvasivaBIPAP"
                      )
                    }
                  />
                );
              })}
            </RadioGroup>
          </Stack>

          {data.ventilacaoNaoInvasivaBIPAP === "50" && (
            <ColumnSpan2>
              <FieldDatePicker
                label="Data de início"
                value={data.bipapDataInicio}
                maxDate={dayjs(new Date())}
                setValue={(value) =>
                  setData((prevState) => ({
                    ...prevState,
                    bipapDataInicio: formatDateISO8601(value),
                  }))
                }
                openTo="year"
                labelDatePicker={"dd/mm/yyyy"}
              />

              <FieldSelect
                label="Duração"
                value={data.bipapDuracao}
                setValue={(value) =>
                  setData((prevState) => ({
                    ...prevState,
                    bipapDuracao: value,
                  }))
                }
                items={ventilacaoNaoInvasivaDuracaoOptions.map((c) => {
                  return { id: c.value, label: c.key };
                })}
              />
            </ColumnSpan2>
          )}
        </Stack>
        <Stack className="templateGridForm">
          <Stack>
            <Stack direction="row" className="labelText">
              Faz uso de traqueostomia? <IconDiamond fill="#FC8518" />
            </Stack>
            <RadioGroup row>
              {simOuNaoOptions.map(({ key, value }) => {
                return (
                  <FormControlLabel
                    value={value}
                    control={<Radio />}
                    label={key}
                    key={value}
                    checked={data.traquestomia === value}
                    onChange={(e) =>
                      handleSetData(e.target.value, "traquestomia")
                    }
                  />
                );
              })}
            </RadioGroup>
          </Stack>

          {data.traquestomia === "50" && (
            <ColumnSpan2>
              <FieldDatePicker
                label="Data de início"
                value={data.traqueostomiaDataInicio}
                maxDate={dayjs(new Date())}
                setValue={(value) =>
                  setData((prevState) => ({
                    ...prevState,
                    traqueostomiaDataInicio: formatDateISO8601(value),
                  }))
                }
                openTo="year"
                labelDatePicker={"dd/mm/yyyy"}
              />

              <FieldSelect
                label="Tipo de procedimento?"
                value={data.traqueostomiaProcedimento}
                setValue={(value) =>
                  setData((prevState) => ({
                    ...prevState,
                    traqueostomiaProcedimento: value,
                  }))
                }
                items={traqueostomiaProcedimentoOptions.map((c) => {
                  return { id: c.value, label: c.key };
                })}
              />
            </ColumnSpan2>
          )}
        </Stack>
        <Stack className="templateGridForm">
          <Stack>
            <Stack direction="row" className="labelText">
              Faz uso de gastrostomia? <IconDiamond fill="#FC8518" />
            </Stack>
            <RadioGroup row>
              {simOuNaoOptions.map(({ key, value }) => {
                return (
                  <FormControlLabel
                    value={value}
                    control={<Radio />}
                    label={key}
                    key={value}
                    checked={data.gastrostomia === value}
                    onChange={(e) =>
                      handleSetData(e.target.value, "gastrostomia")
                    }
                  />
                );
              })}
            </RadioGroup>
          </Stack>

          {data.gastrostomia === "50" && (
            <ColumnSpan2>
              <FieldDatePicker
                label="Data de início"
                value={data.gastrostomiaDataInicio}
                maxDate={dayjs(new Date())}
                setValue={(value) =>
                  setData((prevState) => ({
                    ...prevState,
                    gastrostomiaDataInicio: formatDateISO8601(value),
                  }))
                }
                openTo="year"
                labelDatePicker={"dd/mm/yyyy"}
              />
              <Stack></Stack>
            </ColumnSpan2>
          )}
        </Stack>
        <Stack className="templateGridForm">
          <Stack>
            <Stack direction="row" className="labelText">
              Faz uso de alimentação por sonda?
            </Stack>
            <RadioGroup row>
              {simOuNaoOptions.map(({ key, value }) => {
                return (
                  <FormControlLabel
                    value={value}
                    control={<Radio />}
                    label={key}
                    key={value}
                    checked={data.sondaNasogastrica === value}
                    onChange={(e) =>
                      handleSetData(e.target.value, "sondaNasogastrica")
                    }
                  />
                );
              })}
            </RadioGroup>
          </Stack>

          {data.sondaNasogastrica === "50" && (
            <ColumnSpan2>
              <FieldDatePicker
                label="Data de início"
                value={data.sondaNasogastricaDataInicio}
                maxDate={dayjs(new Date())}
                setValue={(value) =>
                  setData((prevState) => ({
                    ...prevState,
                    sondaNasogastricaDataInicio: formatDateISO8601(value),
                  }))
                }
                openTo="year"
                labelDatePicker={"dd/mm/yyyy"}
              />
              <Stack></Stack>
            </ColumnSpan2>
          )}
        </Stack>

        <Stack className="templateGridForm">
          <Stack>
            <Stack direction="row" className="labelText">
              Faz uso de cought assist?
            </Stack>
            <RadioGroup row>
              {simOuNaoOptions.map(({ key, value }) => {
                return (
                  <FormControlLabel
                    value={value}
                    control={<Radio />}
                    label={key}
                    key={value}
                    checked={data.coughAssist === value}
                    onChange={(e) =>
                      handleSetData(e.target.value, "coughAssist")
                    }
                  />
                );
              })}
            </RadioGroup>
          </Stack>
        </Stack>

        <Stack className="templateGridForm">
          <Stack>
            <Stack direction="row" className="labelText">
              Tecnologia de comunicação <IconDiamond fill="#FC8518" />
            </Stack>
            <RadioGroup row>
              {simOuNaoOptions.map(({ key, value }) => {
                return (
                  <FormControlLabel
                    value={value}
                    control={<Radio />}
                    label={key}
                    key={value}
                    checked={data.tecnologiaComunicacao === value}
                    onChange={(e) =>
                      handleSetData(e.target.value, "tecnologiaComunicacao")
                    }
                  />
                );
              })}
            </RadioGroup>
          </Stack>
        </Stack>

        <Stack className="templateGridForm">
          <Stack>
            <Stack direction="row" className="labelText">
              Faz uso de assistência domiciliar?
            </Stack>
            <RadioGroup row>
              {simOuNaoOptions.map(({ key, value }) => {
                return (
                  <FormControlLabel
                    value={value}
                    control={<Radio />}
                    label={key}
                    key={value}
                    checked={data.assistenciaDomiciliar === value}
                    onChange={(e) =>
                      handleSetData(e.target.value, "assistenciaDomiciliar")
                    }
                  />
                );
              })}
            </RadioGroup>
          </Stack>
        </Stack>
        <Stack>
          <Stack>
            <Stack direction="row" className="labelText">
              Faz uso da multidisciplinaridade oferecida?{" "}
              <IconDiamond fill="#FC8518" />
            </Stack>
            <RadioGroup row>
              {simOuNaoOptions.map(({ key, value }) => {
                return (
                  <FormControlLabel
                    value={value}
                    control={<Radio />}
                    label={key}
                    key={value}
                    checked={data.multidisciplinar === value}
                    onChange={(e) =>
                      handleSetData(e.target.value, "multidisciplinar")
                    }
                  />
                );
              })}
            </RadioGroup>
          </Stack>

          {data.multidisciplinar === "50" && (
            <Stack sx={{ mt: "0 !important" }}>
              <Stack direction="row">Quais?</Stack>
              <FormGroup className="templateGridFormCheckbox CheckboxColor">
                {multidisciplinaridadeTipoOptions.map(({ key, value }) => {
                  return (
                    <FormControlLabel
                      control={<Checkbox />}
                      label={key}
                      value={value}
                      key={value}
                      onClick={(e) =>
                        handleCheckedField(e, "multidisciplinarTipo")
                      }
                      checked={data.multidisciplinarTipo.includes(value)}
                    />
                  );
                })}
              </FormGroup>
            </Stack>
          )}
        </Stack>

        <Stack className="templateGridForm">
          <Stack>
            <Stack direction="row" className="labelText">
              Faz uso de cadeira de rodas? <IconDiamond fill="#FC8518" />
            </Stack>
            <RadioGroup row>
              {simOuNaoOptions.map(({ key, value }) => {
                return (
                  <FormControlLabel
                    value={value}
                    control={<Radio />}
                    label={key}
                    key={value}
                    checked={data.usoCadeiraDeRodas === value}
                    onChange={(e) =>
                      handleSetData(e.target.value, "usoCadeiraDeRodas")
                    }
                  />
                );
              })}
            </RadioGroup>
          </Stack>

          {data.usoCadeiraDeRodas === "50" && (
            <ColumnSpan2>
              <Stack width="100%">
                <Stack direction="row" className="labelText">
                  Tipo de procedimento?
                </Stack>
                <RadioGroup row>
                  {tipoProcedimentoOptions.map(({ key, value }) => {
                    return (
                      <FormControlLabel
                        value={value}
                        checked={data.tipoProcedimento === value}
                        control={
                          <Radio
                            onChange={() =>
                              setData((prevState) => ({
                                ...prevState,
                                tipoProcedimento: value,
                              }))
                            }
                          />
                        }
                        label={key}
                        key={key}
                      />
                    );
                  })}
                </RadioGroup>
              </Stack>
              <Stack></Stack>
            </ColumnSpan2>
          )}
        </Stack>

        <Stack
          direction="row"
          sx={{
            display: "flex",
            justifyContent: "space-between",
            mt: 3,
          }}
        >
          <Button variant="outlined" className="buttonText cancel">
            Cancelar
          </Button>
          <Button
            variant="contained"
            type="submit"
            name="anamneseNeurologica"
            className="buttonText submit"
          >
            Salvar
          </Button>
        </Stack>
      </form>
    </Stack>
  );
}
